// @ts-nocheck
/* eslint-disable */
export const chevronRightIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.39309 1L4 2.47597L9.21383 8L4 13.524L5.39309 15L12 8L5.39309 1Z" fill="currentColor"/></svg>`,
    name: 'chevron-right' as const
};